import React, { useState, useEffect } from 'react';
import AiUsagePanel from './AiUsagePanel';
import ActivityPanel from './ActivityPanel';
import AdminLogin from './AdminLogin';

// Standalone /admin portal. Self-gated by the admin_token cookie (env-credential
// auth) — independent of the user login. Left-nav switches between sections.
export default function AdminPortal() {
  const [authed, setAuthed] = useState(null); // null = checking
  const [section, setSection] = useState('ai-usage');

  useEffect(() => {
    let cancelled = false;
    fetch('/api/admin/auth/session', { credentials: 'include' })
      .then((r) => r.json())
      .then((j) => { if (!cancelled) setAuthed(!!j.authenticated); })
      .catch(() => { if (!cancelled) setAuthed(false); });
    return () => { cancelled = true; };
  }, []);

  const logout = async () => {
    try { await fetch('/api/admin/auth/logout', { method: 'POST', credentials: 'include' }); } catch (_) {}
    setAuthed(false);
  };

  if (authed === null) {
    return <div className="min-h-screen flex items-center justify-center text-gray-400">Loading…</div>;
  }
  if (!authed) {
    return <AdminLogin onSuccess={() => setAuthed(true)} />;
  }

  const NavBtn = ({ id, label }) => (
    <button
      onClick={() => setSection(id)}
      className={`w-full text-left px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
        section === id ? 'bg-[#00aef7] text-white' : 'text-gray-600 hover:bg-gray-100'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="min-h-screen flex bg-gray-50">
      <aside className="w-56 shrink-0 bg-white border-r border-gray-200 flex flex-col p-3">
        <div className="px-2 py-3 mb-2">
          <div className="text-lg font-bold text-gray-900">eHandshake</div>
          <div className="text-xs text-gray-400">Admin</div>
        </div>
        <nav className="space-y-1 flex-1">
          <NavBtn id="ai-usage" label="AI Usage & Cost" />
          <NavBtn id="activity" label="Signup & Login Activity" />
        </nav>
        <button onClick={logout} className="mt-2 px-4 py-2 rounded-lg text-sm text-gray-500 hover:bg-gray-100 text-left">
          Sign out
        </button>
      </aside>

      <main className="flex-1 p-6 overflow-auto">
        {section === 'ai-usage' ? <AiUsagePanel /> : <ActivityPanel />}
      </main>
    </div>
  );
}
